import { Box, Skeleton, Stack } from "@mui/material";
import React from "react";

const TourMediaGallerySkeleton: React.FC = () => (
  <Stack
    data-testid="tour-media-gallery-skeleton"
    id="tour-media-gallery"
    component="section"
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    gap={2}
    sx={{
      borderRadius: "20px",
      marginTop: { xs: "24px", md: "40px" },
      paddingX: { lg: "0px" }
    }}
  >
    {/* Video Box Skeleton */}
    <Box
      sx={{
        borderTopLeftRadius: "20px",
        borderBottomLeftRadius: "20px",
        borderTopRightRadius: { xs: "20px", lg: 0 },
        borderBottomRightRadius: { xs: "20px", lg: 0 },
        position: "relative",
        overflow: "hidden",
        width: { xs: "100%", lg: "555px" },
        height: { lg: "312px" },
        aspectRatio: "555 / 312"
      }}
    >
      <Skeleton
        variant="rectangular"
        width="100%"
        height="100%"
        animation="wave"
        sx={{
          borderTopLeftRadius: "20px",
          borderBottomLeftRadius: "20px",
          borderTopRightRadius: {xs: "20px", lg: 0},
          borderBottomRightRadius: {xs: "20px", lg: 0}
        }}
      />

      {/* Button Skeleton for Mobile */}
      <Box
        sx={{
          display: {lg: "none"},
          position: "absolute",
          bottom: "21px",
          right: "21px"
        }}
      >
        <Skeleton
          variant="rounded"
          width={120}
          height={40}
          animation="wave"
          sx={{ borderRadius: "10rem" }}
        />
      </Box>
    </Box>

    {/* Desktop Image Skeletons */}
    <>
      {/* First Image Box Skeleton */}
      <Skeleton
        variant="rectangular"
        width={352}
        height={312}
        animation="wave"
        sx={{
          display: {xs: "none", lg: "inline"}
        }}
      />

      {/* Second Image Box Skeleton with Button */}
      <Box
        sx={{
          position: "relative",
          width: 352,
          height: 312,
          display: {xs: "none", lg: "inline"}
        }}
      >
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          animation="wave"
          sx={{
            borderTopRightRadius: "20px",
            borderBottomRightRadius: "20px"
          }}
        />

        {/* Button Skeleton for Desktop */}
        <Box
          sx={{
            position: "absolute",
            bottom: "21px",
            right: "21px"
          }}
        >
          <Skeleton
            variant="rounded"
            width={120}
            height={40}
            animation="wave"
            sx={{ borderRadius: "10rem" }}
          />
        </Box>
      </Box>
    </>
  </Stack>
);

export default TourMediaGallerySkeleton;
